var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-block",class:{ 'fullscreen': _vm.fullscreen }},_vm._l((_vm.messages),function(message){return _c('Message',{key:message.id,attrs:{"message":message,"fullscreen":_vm.fullscreen}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }